//* OPCION 2
// export default {
//   '--app-primary-color': '#830051',
//   '--app-secondary-color': '#4d0030',
//   '--app-tertiary-color': '#ebefee',
//   '--app-disabled-color': 'hsl(220, 12%, 95%)',
//   '--sidebar-bg-color': '#4d0030',
//   '--sidebar-icon-color': 'hsl(0, 0%, 100%)',
//   '--sidebar-text-color': 'hsl(0, 0%, 100%)',
//   '--sidebar-active-bg-color': '#d0006f',
//   '--sidebar-active-text-color': '#ffffffff'
// };

//* OPCION 1
export const BASE = {
  '--app-primary-color': '#830051',
  '--app-secondary-color': '#4d0030',
  '--app-tertiary-color': '#ebefee',
  '--app-disabled-color': 'hsl(220, 12%, 95%)',
  '--sidebar-bg-color': '#4d0030',
  '--sidebar-icon-color': 'hsl(0, 0%, 100%)',
  '--sidebar-text-color': 'hsl(0, 0%, 100%)',
  '--sidebar-active-bg-color': '#fbfbfbff',
  '--sidebar-active-text-color': '#830051'
};

export const HOSPITAL_SANTA_CRUZ = {
  '--app-primary-color': '#006AA9',
  '--app-secondary-color': '#0089c8',
  '--app-tertiary-color': '#ebefee',
  '--app-disabled-color': 'hsl(220, 12%, 95%)',
  '--sidebar-bg-color': '#004E84',
  '--sidebar-icon-color': 'hsl(0, 0%, 100%)',
  '--sidebar-text-color': 'hsl(0, 0%, 100%)',
  '--sidebar-active-bg-color': '#00B2F5',
  '--sidebar-active-text-color': 'hsl(0, 0%, 100%)'
};

export const PROSALCO = {
  '--app-primary-color': '#2D3784',
  '--app-secondary-color': '#0089c8',
  '--app-tertiary-color': '#ebefee',
  '--app-disabled-color': 'hsl(220, 12%, 95%)',
  '--sidebar-bg-color': '#2D3784',
  '--sidebar-icon-color': 'hsl(0, 0%, 100%)',
  '--sidebar-text-color': 'hsl(0, 0%, 100%)',
  '--sidebar-active-bg-color': '#0089c8',
  '--sidebar-active-text-color': 'hsl(0, 0%, 100%)'
};

export const IPS_PREVENTIVA = {
  '--app-primary-color': '#1754A5',
  '--app-secondary-color': '#01A4D2',
  '--app-tertiary-color': '#ebefee',
  '--app-disabled-color': 'hsl(220, 12%, 95%)',
  '--sidebar-bg-color': '#1754A5',
  '--sidebar-icon-color': 'hsl(0, 0%, 100%)',
  '--sidebar-text-color': 'hsl(0, 0%, 100%)',
  '--sidebar-active-bg-color': '#F48222',
  '--sidebar-active-text-color': 'hsl(0, 0%, 100%)'
};

export const PROMEDAN = {
  '--app-primary-color': '#1271b7',
  '--app-secondary-color': '#01A4D2',
  '--app-tertiary-color': '#ebefee',
  '--app-disabled-color': 'hsl(220, 12%, 95%)',
  '--sidebar-bg-color': '#1271b7',
  '--sidebar-icon-color': 'hsl(0, 0%, 100%)',
  '--sidebar-text-color': 'hsl(0, 0%, 100%)',
  '--sidebar-active-bg-color': '#F48222',
  '--sidebar-active-text-color': 'hsl(0, 0%, 100%)'
};
